import PropTypes from 'prop-types';
import { useProgressBar } from 'react-aria';
import color from 'client/utils/constants/GDS/js/color';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const ProgressCircle = (props) => {
    const { isIndeterminate, value, minValue, maxValue, size } = props;
    const { progressBarProps } = useProgressBar(props);

    const center = size / 2;
    const strokeWidth = size / 12;
    const r = (size / 2) - strokeWidth;
    const c = 2 * r * Math.PI;
    const percentage = isIndeterminate
        ? 0.25
        : (value - minValue) / (maxValue - minValue);
    const offset = c - percentage * c;

    return (
        <div data-testid={props['data-testid'] + '.container'}>
            <svg
                {...progressBarProps}
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                fill="none"
                strokeWidth={strokeWidth}
            >
                <circle
                    role="presentation"
                    cx={center}
                    cy={center}
                    r={r}
                    stroke={color['mid-grey']}
                />
                <circle
                    role="presentation"
                    cx={center}
                    cy={center}
                    r={r}
                    stroke={color.blue}
                    strokeDasharray={`${c} ${c}`}
                    strokeDashoffset={offset}
                    transform="rotate(-90 16 16)"
                >
                    {props.isIndeterminate &&
                        (
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                begin="0s"
                                dur="1s"
                                from={`0 ${center} ${center}`}
                                to={`360 ${center} ${center}`}
                                repeatCount="indefinite"
                            />
                        )}
                </circle>
            </svg>
        </div>
    );
};

ProgressCircle.propTypes = {
    ...defaultAriaProps,
    isIndeterminate: PropTypes.bool,
    value: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    size: PropTypes.number

};

ProgressCircle.defaultProps = {
    'data-testid': 'loading',
    'aria-label': 'loading...',
    value: 0,
    minValue: 0,
    maxValue: 100,
    size: 32
};

export default ProgressCircle;
